"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var dice_1 = require("./dice");
var styled_components_1 = require("styled-components");
var dot_1 = require("./dot");
var D6Elem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  box-sizing: border-box;\n"])));
var DiceOutline = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  border-width: 1px;\n  border-style: solid;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  border-width: 1px;\n  border-style: solid;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var D6 = /** @class */ (function (_super) {
    __extends(D6, _super);
    function D6() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    D6.prototype.render = function () {
        var _a = this.props.diceProps, background = _a.background, size = _a.size, color = _a.color, value = _a.value, shape = _a.shape;
        var width = size + "px";
        var height = size + "px";
        var borderRadius = size / 8 + "px";
        var outline = shape === dice_1.Shape.Outline;
        var style = shape === dice_1.Shape.Solid ? { background: background } : {};
        return (React.createElement(D6Elem, { className: "total" + value, style: __assign({ width: width, height: height, borderRadius: borderRadius }, style) },
            D6.range(Number(value)).map(function (num) { return React.createElement(dot_1.Dot, __assign({}, { size: size, value: value, num: num, color: color })); }),
            outline && React.createElement(DiceOutline, { style: { borderColor: background, borderRadius: borderRadius } })));
    };
    D6.range = function (count) {
        var arr = [];
        for (var i = 1; i <= count; i++) {
            arr.push(i);
        }
        return arr;
    };
    return D6;
}(React.Component));
exports.D6 = D6;
var templateObject_1, templateObject_2;
//# sourceMappingURL=d6.js.map